import PreQuestionCheckbox from './PreQuestionCheckbox';

export default PreQuestionCheckbox;
